/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {Data2} from './Data2';
import {Data2FromJSON, Data2FromJSONTyped, Data2ToJSON} from './Data2';

/**
 *
 * @export
 * @interface TechProcessActionResult
 */
export interface TechProcessActionResult {
  /**
   *
   * @type {boolean}
   * @memberof TechProcessActionResult
   */
  treeChanged?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TechProcessActionResult
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof TechProcessActionResult
   */
  errorMsg?: string | null;
  /**
   *
   * @type {Data2}
   * @memberof TechProcessActionResult
   */
  data: Data2;
}

/**
 * Check if a given object implements the TechProcessActionResult interface.
 */
export function instanceOfTechProcessActionResult(value: object): value is TechProcessActionResult {
  if (!('success' in value) || value['success'] === undefined) return false;
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function TechProcessActionResultFromJSON(json: any): TechProcessActionResult {
  return TechProcessActionResultFromJSONTyped(json, false);
}

export function TechProcessActionResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TechProcessActionResult {
  if (json == null) {
    return json;
  }
  return {
    treeChanged: json['tree_changed'] == null ? undefined : json['tree_changed'],
    success: json['success'],
    errorMsg: json['error_msg'] == null ? undefined : json['error_msg'],
    data: Data2FromJSON(json['data'])
  };
}

export function TechProcessActionResultToJSON(value?: TechProcessActionResult | null): any {
  if (value == null) {
    return value;
  }
  return {
    tree_changed: value['treeChanged'],
    success: value['success'],
    error_msg: value['errorMsg'],
    data: Data2ToJSON(value['data'])
  };
}
